import { jsx } from "react/jsx-runtime";
import { StyledLocationPin } from "./styles.js";
function IconOnly({ entry }) {
  if (!entry) return null;
  return /* @__PURE__ */ jsx(StyledLocationPin, { uniqueId: "findawarehouse-icon" });
}
export {
  IconOnly
};
